import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded'
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded'
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded'
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded'
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded'
import BuildCircleRoundedIcon from '@mui/icons-material/BuildCircleRounded'
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded'

// color           = vivid icon bubble / card accent color
// cardGradient    = linear-gradient for dashboard cards (light mode)
// cardGradientDark= linear-gradient for dashboard cards (dark mode)
// chipBg          = navbar chip background color
const routeMeta = [
    {
        path: '/', label: 'Home', accessKey: null, Icon: HomeRoundedIcon,
        color: '#2563eb', cardGradient: 'linear-gradient(135deg,#dbeafe,#bfdbfe)',
        cardGradientDark: 'linear-gradient(135deg,#1e3a5f,#162040)', chipBg: 'rgba(255,255,255,0.18)'
    },
    {
        path: '/audiometry', label: 'Audiometry', accessKey: 'audiometry', Icon: GraphicEqRoundedIcon,
        color: '#3b82f6', cardGradient: 'linear-gradient(135deg,#dbeafe,#93c5fd)',
        cardGradientDark: 'linear-gradient(135deg,#1e3a5f,#0f2040)', chipBg: '#3b82f6'
    },
    {
        path: '/inventory', label: 'Inventory', accessKey: 'inventory', Icon: Inventory2RoundedIcon,
        color: '#8b5cf6', cardGradient: 'linear-gradient(135deg,#ede9fe,#c4b5fd)',
        cardGradientDark: 'linear-gradient(135deg,#2e1b5e,#1a103a)', chipBg: '#8b5cf6'
    },
    {
        path: '/generate-invoice', label: 'Generate Invoice', accessKey: 'generate_invoice', Icon: ReceiptLongRoundedIcon,
        color: '#10b981', cardGradient: 'linear-gradient(135deg,#d1fae5,#6ee7b7)',
        cardGradientDark: 'linear-gradient(135deg,#0d3b2a,#061f16)', chipBg: '#10b981'
    },
    {
        path: '/sales-report', label: 'Sales Report', accessKey: 'sales_report', Icon: QueryStatsRoundedIcon,
        color: '#f43f5e', cardGradient: 'linear-gradient(135deg,#ffe4e6,#fda4af)',
        cardGradientDark: 'linear-gradient(135deg,#3b0f18,#20070d)', chipBg: '#f43f5e'
    },
    {
        path: '/reports', label: 'Reports', accessKey: 'sales_report', Icon: AssessmentRoundedIcon,
        color: '#14b8a6', cardGradient: 'linear-gradient(135deg,#ccfbf1,#99f6e4)',
        cardGradientDark: 'linear-gradient(135deg,#0b3a34,#061f1c)', chipBg: '#14b8a6'
    },
    {
        path: '/patients', label: 'Patients', accessKey: 'patients', Icon: PeopleRoundedIcon,
        color: '#f97316', cardGradient: 'linear-gradient(135deg,#ffedd5,#fdba74)',
        cardGradientDark: 'linear-gradient(135deg,#3b1f0a,#1f0f04)', chipBg: '#f97316'
    },
    {
        path: '/service', label: 'Service', accessKey: 'service', Icon: BuildCircleRoundedIcon,
        color: '#06b6d4', cardGradient: 'linear-gradient(135deg,#cffafe,#67e8f9)',
        cardGradientDark: 'linear-gradient(135deg,#0a2e3a,#041820)', chipBg: '#06b6d4'
    },
    {
        path: '/admin-panel', label: 'Admin Panel', accessKey: 'admin_panel', Icon: AdminPanelSettingsRoundedIcon,
        color: '#f59e0b', cardGradient: 'linear-gradient(135deg,#fef9c3,#fde047)',
        cardGradientDark: 'linear-gradient(135deg,#3b2e0a,#1f1804)', chipBg: '#f59e0b'
    }
]

export default routeMeta
